import { createContext } from "react";

export const ThemeSelectorContext = createContext({
  client: null,
  clientDisplayName: null,
  card: null,
  groupNumber: null,
});
